import PricingRulesCard from './PricingRulesCard'

export default PricingRulesCard
